/**
 * RestrictedAccessPage (Phase 7: IP 화이트리스트)
 *
 * **목적:**
 * - 사내망 IP가 아닌 곳에서 접속 시 표시되는 페이지
 * - 회사 네트워크 또는 VPN 사용 안내
 *
 * **표시 조건:**
 * - App.tsx에서 /checkIP API를 호출한 결과 IP가 거부된 경우
 * - 허용 IP: 59.13.192.250, 59.12.234.2
 *
 * **디자인:**
 * - 간결하고 명확한 메시지
 * - 경고 아이콘과 빨간색 테마
 * - 접속 방법 안내 (사무실 네트워크, VPN)
 */

import React from 'react';
import { AlertTriangle } from 'lucide-react';

export const RestrictedAccessPage: React.FC = () => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      padding: '40px',
      backgroundColor: '#f9fafb',
    }}>
      <AlertTriangle
        size={80}
        style={{
          color: '#dc2626',
          marginBottom: '24px'
        }}
      />

      <h1 style={{
        fontSize: '32px',
        fontWeight: 'bold',
        color: '#111827',
        marginBottom: '16px',
        textAlign: 'center',
      }}>
        접근이 제한되었습니다
      </h1>

      <p style={{
        fontSize: '18px',
        color: '#6b7280',
        marginBottom: '32px',
        textAlign: 'center',
        maxWidth: '600px',
        lineHeight: '1.6',
      }}>
        nGle-Works ERP는 사내망에서만 접속 가능합니다.
        <br />
        회사 네트워크 또는 VPN을 사용해주세요.
      </p>

      <div style={{
        padding: '24px 32px',
        backgroundColor: '#fee2e2',
        borderRadius: '8px',
        border: '1px solid #fecaca',
        maxWidth: '600px',
        width: '100%',
      }}>
        <h2 style={{
          fontSize: '16px',
          fontWeight: '600',
          color: '#991b1b',
          marginBottom: '16px',
        }}>
          접속 방법
        </h2>
        <ul style={{
          fontSize: '14px',
          color: '#7f1d1d',
          lineHeight: '2',
          paddingLeft: '24px',
          margin: 0,
        }}>
          <li>회사 사무실 네트워크에서 접속</li>
          <li>회사 VPN을 통해 접속</li>
          <li>문의: IT 관리자에게 연락</li>
        </ul>
      </div>

      <div style={{
        marginTop: '32px',
        padding: '16px 24px',
        backgroundColor: '#f3f4f6',
        borderRadius: '6px',
        border: '1px solid #e5e7eb',
        maxWidth: '600px',
        width: '100%',
      }}>
        <p style={{
          fontSize: '13px',
          color: '#6b7280',
          margin: 0,
          textAlign: 'center',
        }}>
          <strong>보안 정책:</strong> 이 시스템은 사내 전용이며,
          승인된 IP 주소에서만 접근할 수 있습니다.
        </p>
      </div>

      <p style={{
        fontSize: '14px',
        color: '#9ca3af',
        marginTop: '32px',
      }}>
        문제가 지속되면 IT 관리자에게 문의하세요.
      </p>
    </div>
  );
};
